import Spinner from './spinner';

type LoadingProps = {
  message?: string;
};

const Loading = ({ message }: LoadingProps) => (
  <div className="flex grow flex-col items-center justify-center gap-3">
    <Spinner />
    {message ? (
      <p
        aria-live="polite"
        className="text-muted-foreground px-4 text-center text-sm"
        role="status"
      >
        {message}
      </p>
    ) : null}
  </div>
);

export default Loading;
